import React from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * Storage key for the chosen appearance. Shared with the pre-paint script in
 * index.html, which reads this exact key before React mounts — change one and
 * you must change the other, or every load flashes the wrong ground.
 */
export const THEME_STORAGE_KEY = 'mohairnotes-theme';

/**
 * The app was light-only until the Warm Clinic port: `forcedTheme="light"` was
 * pinned here and `color-scheme: light` in index.css. Both are gone, and the
 * palette now carries a full `.dark` block.
 *
 * `defaultTheme` is "light", not "system" — deviating from the Laravel app,
 * which defaults to dark. Every existing clinician has only ever seen this app
 * light, and defaulting to system would flip anyone on a dark OS without their
 * asking. Dark is one click away in the top bar instead.
 */
export function ThemeProvider({ children, ...props }: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      enableSystem
      disableTransitionOnChange
      attribute="class"
      defaultTheme="light"
      storageKey={THEME_STORAGE_KEY}
      {...props}>
      {children}
    </NextThemesProvider>
  );
}
